import type { MapBBox } from './MapCanvas'

/** Границы вьюпорта в том виде, в каком их отдаёт MapLibre `map.getBounds()`. */
export interface ViewportBounds {
  west: number
  east: number
  south: number
  north: number
}

const FULL_TURN = 360

/** Вьюпорт карты → канонический bbox: долгота непрерывна на восток.
 *
 *  MapLibre при виде на Берингово море отдаёт запад за −180 (например −189.2):
 *  бэкенд такой регион отвергал (HTTP 422 на «Обновить»), а SQL-фильтр
 *  `longitude BETWEEN lon_min AND lon_max` не давал ни одной строки. Канон
 *  проекта — `lon_min ∈ [−180, 180)`, `lon_max = lon_min + ширина`, где
 *  `lon_max > 180` и означает переход через дату (тот же вид, что у
 *  `DEFAULT_REGION` с `lon_max=185` на бэкенде). */
export function canonicalBBox(b: ViewportBounds): MapBBox {
  const span = Math.min(b.east - b.west, FULL_TURN)
  const lonMin = (((b.west + 180) % FULL_TURN) + FULL_TURN) % FULL_TURN - 180
  return {
    lat_min: b.south,
    lat_max: b.north,
    lon_min: lonMin,
    lon_max: lonMin + span,
  }
}
